import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material';
import { Inject, Component } from '@angular/core';
import { TranslationService } from '../../common/services/languages/translation.service';
import { MatIcon } from '@angular/material/icon';
import { NgClass } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-confirmation-bar',
    templateUrl: './confirmation-bar.component.html',
    styleUrls: ['./confirmation-bar.component.scss'],
    imports: [MatIcon, NgClass, TranslatePipe]
})
export class ConfirmationBarComponent {
  /**
  * @var CONFIRMATION_MESSAGES to store the messages for each type of confirmation
  **/
  static CONFIRMATION_MESSAGES = {
    'submit': 'label.submit-success',
    'failed': 'label.submit-failed',
    'review-approve': 'label.approve-success',
    'review-reject': 'label.reject-success',
    'rejected': 'label.products-rejected',
    'updated': 'label.products-created'
  };
  /**
  * @var message to store the message for the corresponding type
  **/
  message: string;

  constructor(
    private snackBarRef: MatSnackBarRef<ConfirmationBarComponent>,
    public translate: TranslationService,
    @Inject(MAT_SNACK_BAR_DATA) public data: any,
  ) {
    this.message = !!ConfirmationBarComponent.CONFIRMATION_MESSAGES[data.type] ?
      `confirmation.${ConfirmationBarComponent.CONFIRMATION_MESSAGES[data.type]}` : '';
  }

  /**
  * @method close close the confirmation dialog
  **/
  close(): void {
    this.snackBarRef.dismissWithAction();
  }

  /**
  * @method typeFlag will return success or failed based on data type
  * @arg daya of type any will contains data type
  * @return string of success or failed
  **/
  typeFlag(data: any): string {
    return (data.type === 'submit' || data.type === 'updated' || data.type === 'review-approve' || data.type === 'review-reject') ? 'success' : 'failed' ;
  }
}
